import { useEffect, useRef, useState } from 'react';

import LoaderCircle, {
    DARK_MODE,
} from '@perpay-web/components/base/LoaderCircle/LoaderCircle';
import Step from '@perpay-web/components/base/Step/Step';
import Box from '@perpay-web/components/design-system/Box/Box';
import Stack from '@perpay-web/components/design-system/Stack/Stack';
import cardLoaderTestimonial1 from '@perpay-web/fintech/assets/images/illustrations/cardLoaderTestimonial1.svg';
import cardLoaderTestimonial2 from '@perpay-web/fintech/assets/images/illustrations/cardLoaderTestimonial2.svg';
import cardLoaderTestimonial3 from '@perpay-web/fintech/assets/images/illustrations/cardLoaderTestimonial3.svg';
import { useFullHeader } from '@perpay-web/fintech/hooks/useFullHeaderContext';
import { useMount } from '@perpay-web/hooks/useMount';
import { useMountAndUnmount } from '@perpay-web/hooks/useMountAndUnmount';
import { useSteps } from '@perpay-web/hooks/useSteps';
import { noop } from '@perpay-web/utils/noop';

import styles from './CardSubmittingAcceptance.scss';

const STEP_TIME_MS = 1000 * 4;

// NOTE: We use number steps here because the steps themselves are not significant,
// it's only for iterating through the testimonial images.
const TESTIMONIAL_STEPS = [0, 1, 2];

const CardSubmittingAcceptance = ({ onMount = noop }) => {
    useMount(() => onMount());
    const { step, setStep } = useSteps(TESTIMONIAL_STEPS);
    const [showSlowMessage, setShowSlowMessage] = useState(false);
    const timeoutRef = useRef(null);

    useFullHeader(null);

    useMountAndUnmount(() => () => {
        if (timeoutRef.current) {
            window.clearTimeout(timeoutRef.current);
        }
    });

    useEffect(() => {
        timeoutRef.current = window.setTimeout(() => {
            const nextStep = (step + 1) % 3;
            setShowSlowMessage(true);
            setStep(nextStep);
        }, STEP_TIME_MS);

        return () => {
            if (timeoutRef.current) {
                window.clearTimeout(timeoutRef.current);
            }
        };
    }, [step, setStep]);

    return (
        <Stack className={styles.container}>
            <div className={styles.top}>
                <div className={styles['loader-wrapper']}>
                    <LoaderCircle className={styles.loader} mode={DARK_MODE} />
                </div>
            </div>
            <div className={styles.copy}>
                {!showSlowMessage ? (
                    <>
                        <span className={styles.nowrap}>While you wait...</span>{' '}
                        <span className={styles.nowrap}>
                            see what our customers say
                        </span>
                    </>
                ) : (
                    <>
                        <span className={styles.nowrap}>Almost there...</span>{' '}
                        <span className={styles.nowrap}>
                            just a few more seconds
                        </span>
                    </>
                )}
            </div>
            <Box className={styles.testimonials}>
                <Step
                    name={0}
                    current={step}
                    render={() => (
                        <img
                            className={styles.testimonial}
                            src={cardLoaderTestimonial1}
                            alt=''
                        />
                    )}
                />
                <Step
                    name={1}
                    current={step}
                    render={() => (
                        <img
                            className={styles.testimonial}
                            src={cardLoaderTestimonial2}
                            alt=''
                        />
                    )}
                />
                <Step
                    name={2}
                    current={step}
                    render={() => (
                        <img
                            className={styles.testimonial}
                            src={cardLoaderTestimonial3}
                            alt=''
                        />
                    )}
                />
            </Box>
        </Stack>
    );
};

export default CardSubmittingAcceptance;
